(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const TRANSPARENT_HEADER_SCROLL_THRESHOLD = 5;
  const DESKTOP_LOGO_MEDIA_QUERY = '(min-width: 990px)';
  const MOBILE_SURFACE_LUMINANCE_THRESHOLD = 150;

  const isDarkSurfaceColor = (colorString) => {
    if (!colorString) return false;
    const matches = colorString.match(/\d+(\.\d+)?/g);
    if (!matches || matches.length < 3) return false;
    const [r, g, b] = matches.slice(0, 3).map(Number);
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    return luminance < MOBILE_SURFACE_LUMINANCE_THRESHOLD;
  };

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.allowTransparentHeader = this.dataset.transparentHeader === 'true';
      this.headerBounds = {};
      this.currentTransparentState = false;
      this.isDarkScheme = false;
      this.mobileSurfaceIsDark = false;
      this.schemeMediaQuery = null;
      this.handleColorSchemeChange = null;
      this.desktopMediaQuery = null;
      this.handleDesktopViewportChange = null;
      this.isDesktopViewport = true;

      this.initializeColorSchemeWatcher();
      this.initializeDesktopViewportWatcher();
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.updateWrapperBackground();
      this.syncMobileSurfaceState({ skipLogoUpdate: true });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      // Re-evaluate after first paint so browsers like Samsung Internet have
      // committed computed background colours to the CSSOM before we read them.
      // Chrome mobile has been seen to need a later checkpoint than rAF alone
      // (e.g. it can still report the OS dark-mode background at that point),
      // so also re-check after full load and once more shortly after as a
      // safety net — syncMobileSurfaceState() is a no-op once the class
      // already matches the actual computed color, so extra calls are cheap.
      requestAnimationFrame(() => {
        this.syncMobileSurfaceState();
      });
      window.addEventListener('load', () => {
        this.syncMobileSurfaceState();
      });
      setTimeout(() => {
        this.syncMobileSurfaceState();
      }, 400);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.schemeMediaQuery && this.handleColorSchemeChange) {
        if (typeof this.schemeMediaQuery.removeEventListener === 'function') {
          this.schemeMediaQuery.removeEventListener('change', this.handleColorSchemeChange);
        } else if (typeof this.schemeMediaQuery.removeListener === 'function') {
          this.schemeMediaQuery.removeListener(this.handleColorSchemeChange);
        }
      }
      if (this.desktopMediaQuery && this.handleDesktopViewportChange) {
        if (typeof this.desktopMediaQuery.removeEventListener === 'function') {
          this.desktopMediaQuery.removeEventListener('change', this.handleDesktopViewportChange);
        } else if (typeof this.desktopMediaQuery.removeListener === 'function') {
          this.desktopMediaQuery.removeListener(this.handleDesktopViewportChange);
        }
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    initializeColorSchemeWatcher() {
      if (typeof window.matchMedia !== 'function') return;
      this.schemeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      if (!this.schemeMediaQuery) return;
      const applySchemeState = (matches) => {
        this.isDarkScheme = matches;
        this.updateSchemeClasses();
        this.syncMobileSurfaceState();
        this.toggleLogoVariants(this.currentTransparentState);
      };
      this.handleColorSchemeChange = (event) => applySchemeState(event.matches);
      applySchemeState(this.schemeMediaQuery.matches);
      if (typeof this.schemeMediaQuery.addEventListener === 'function') {
        this.schemeMediaQuery.addEventListener('change', this.handleColorSchemeChange);
      } else if (typeof this.schemeMediaQuery.addListener === 'function') {
        this.schemeMediaQuery.addListener(this.handleColorSchemeChange);
      }
    }

    initializeDesktopViewportWatcher() {
      if (typeof window.matchMedia !== 'function') return;
      this.desktopMediaQuery = window.matchMedia(DESKTOP_LOGO_MEDIA_QUERY);
      if (!this.desktopMediaQuery) return;
      const applyDesktopState = (matches) => {
        this.isDesktopViewport = matches;
        this.updateSchemeClasses();
        this.syncMobileSurfaceState({ skipLogoUpdate: true });
        this.toggleLogoVariants(this.currentTransparentState);
      };
      this.handleDesktopViewportChange = (event) => applyDesktopState(event.matches);
      applyDesktopState(this.desktopMediaQuery.matches);
      if (typeof this.desktopMediaQuery.addEventListener === 'function') {
        this.desktopMediaQuery.addEventListener('change', this.handleDesktopViewportChange);
      } else if (typeof this.desktopMediaQuery.addListener === 'function') {
        this.desktopMediaQuery.addListener(this.handleDesktopViewportChange);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.updateWrapperBackground(scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    updateWrapperBackground(scrollTop = window.pageYOffset || document.documentElement.scrollTop) {
      const atTop = scrollTop <= TRANSPARENT_HEADER_SCROLL_THRESHOLD;
      const allowDesktopTransparent = this.allowTransparentHeader && this.isDesktopViewport;
      const showTransparentState = allowDesktopTransparent && atTop;
      this.classList.toggle('header-wrapper--transparent', showTransparentState);
      this.classList.toggle('header-wrapper--solid', !showTransparentState);
      this.toggleLogoVariants(showTransparentState);
    }

    toggleLogoVariants(showContrast) {
      this.currentTransparentState = !!showContrast;
      const allowScrollSwap = this.desktopMediaQuery ? this.desktopMediaQuery.matches : true;
      const scrollDrivenContrast = allowScrollSwap && this.currentTransparentState;
      const schemeDrivenContrast = !allowScrollSwap && this.mobileSurfaceIsDark;
      const shouldShowContrast = scrollDrivenContrast || schemeDrivenContrast;
      this.classList.toggle('header-wrapper--show-contrast-logo', shouldShowContrast);
      const logoWrappers = this.querySelectorAll('.header__heading-logo-wrapper--dual');
      if (!logoWrappers.length) {
        return;
      }
      logoWrappers.forEach((wrapper) => {
        wrapper.classList.toggle('header__heading-logo-wrapper--show-contrast', shouldShowContrast);
      });
    }

    syncMobileSurfaceState(options = {}) {
      const { skipLogoUpdate = false } = options;
      if (this.isDesktopViewport) {
        if (this.mobileSurfaceIsDark || this.classList.contains('header-wrapper--mobile-dark-surface') || this.classList.contains('header-wrapper--mobile-light-surface')) {
          this.mobileSurfaceIsDark = false;
          this.classList.remove('header-wrapper--mobile-dark-surface', 'header-wrapper--mobile-light-surface');
          if (!skipLogoUpdate) {
            this.toggleLogoVariants(this.currentTransparentState);
          }
        }
        return;
      }

      const backgroundColor = window.getComputedStyle(this).backgroundColor;
      const isDarkSurface = isDarkSurfaceColor(backgroundColor);
      if (this.mobileSurfaceIsDark === isDarkSurface && this.classList.contains('header-wrapper--mobile-dark-surface') === isDarkSurface) {
        return;
      }

      this.mobileSurfaceIsDark = isDarkSurface;
      this.classList.toggle('header-wrapper--mobile-dark-surface', isDarkSurface);
      this.classList.toggle('header-wrapper--mobile-light-surface', !isDarkSurface);

      // When the surface is confirmed light (e.g. white header in Chrome mobile with
      // OS dark mode), remove the OS-dark-mode class so it doesn't force the contrast logo.
      if (!isDarkSurface) {
        this.classList.remove('header-wrapper--color-scheme-dark');
      }

      if (!skipLogoUpdate) {
        this.toggleLogoVariants(this.currentTransparentState);
      }
    }

    updateSchemeClasses() {
      const allowMobileScheme = !this.isDesktopViewport;
      const applyDarkScheme = allowMobileScheme && this.isDarkScheme;
      this.classList.toggle('header-wrapper--color-scheme-dark', applyDarkScheme);
      if (this.isDesktopViewport) {
        this.classList.remove('header-wrapper--color-scheme-dark');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const initializeHeaderSearchState = () => {
    const wrappers = document.querySelectorAll('.section-header .header-wrapper');
    wrappers.forEach((wrapper) => {
      const searchDetails = wrapper.querySelectorAll('.header__search details');
      if (!searchDetails.length) return;
      const updateState = () => {
        const anyOpen = Array.from(searchDetails).some((details) => details.hasAttribute('open'));
        wrapper.classList.toggle('header-wrapper--search-open', anyOpen);
      };
      searchDetails.forEach((details) => details.addEventListener('toggle', updateState));
      updateState();
    });
  };
  initializeHeaderSearchState();

  const initializeCollectionHover = () => {
    const hoverBar = document.querySelector('[data-collection-hover]');
    if (!hoverBar) return;

    const panels = hoverBar.querySelectorAll('[data-hover-panel]');
    const triggers = document.querySelectorAll('[data-collection-hover-handle]');
    if (!panels.length || !triggers.length) return;

    const desktopMedia = window.matchMedia('(min-width: 990px)');
    let hideTimeout;

    const clearHideTimeout = () => {
      if (!hideTimeout) return;
      window.clearTimeout(hideTimeout);
      hideTimeout = null;
    };

    let lastTrigger = null;

    // ── "Custom" link heartbeat nudge ──
    // A visitor who lingers on a collection panel for 9 straight seconds
    // without clicking anything is plausibly still undecided — this pulses
    // the "Custom" link once, ever, per visitor (never repeats on later
    // visits) as a gentle "or design your own" hint. See the babHeartbeat
    // keyframes in premium-ux.css for the actual animation.
    const CUSTOM_PULSE_DELAY = 9000;
    const CUSTOM_PULSE_STORAGE_KEY = 'babCustomLinkPulseShown';
    let pulseTimeout;

    const clearPulseTimeout = () => {
      if (!pulseTimeout) return;
      window.clearTimeout(pulseTimeout);
      pulseTimeout = null;
    };

    const hasSeenPulse = () => {
      try {
        return window.localStorage.getItem(CUSTOM_PULSE_STORAGE_KEY) === '1';
      } catch (err) {
        return false; // localStorage unavailable (private mode, etc.) — treat as unseen, worst case it just shows again
      }
    };

    const markPulseSeen = () => {
      try {
        window.localStorage.setItem(CUSTOM_PULSE_STORAGE_KEY, '1');
      } catch (err) {
        /* ignore — nothing to persist to, so it may show again next time */
      }
    };

    const schedulePulse = () => {
      clearPulseTimeout();
      if (hasSeenPulse()) return;
      pulseTimeout = window.setTimeout(() => {
        const activePanel = hoverBar.querySelector('[data-hover-panel].is-active');
        const link = activePanel && activePanel.querySelector('.collection-hover__custom-link');
        if (!link) return;
        markPulseSeen();
        link.classList.add('is-pulsing');
        link.addEventListener('animationend', () => link.classList.remove('is-pulsing'), { once: true });
      }, CUSTOM_PULSE_DELAY);
    };

    const deactivate = () => {
      hoverBar.classList.remove('collection-hover--visible');
      panels.forEach((panel) => panel.classList.remove('is-active'));
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      clearPulseTimeout();
    };

    const activate = (handle) => {
      if (!desktopMedia.matches) return;
      let matched = false;
      panels.forEach((panel) => {
        const isMatch = panel.dataset.hoverPanel === handle;
        panel.classList.toggle('is-active', isMatch);
        if (isMatch) matched = true;
      });
      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', (trigger.dataset.collectionHoverHandle === handle && matched).toString());
      });

      if (matched) {
        hoverBar.classList.add('collection-hover--visible');
        schedulePulse();
      } else {
        deactivate();
      }
    };

    const scheduleHide = () => {
      clearHideTimeout();
      hideTimeout = window.setTimeout(() => {
        deactivate();
      }, 350);
    };

    triggers.forEach((trigger) => {
      const handle = trigger.dataset.collectionHoverHandle;
      if (!handle) return;

      ['mouseenter', 'focusin'].forEach((eventName) => {
        trigger.addEventListener(eventName, () => {
          if (!desktopMedia.matches) return;
          clearHideTimeout();
          activate(handle);
          lastTrigger = trigger;
        });
      });

      trigger.addEventListener('mouseleave', () => {
        if (!desktopMedia.matches) return;
        scheduleHide();
      });

      trigger.addEventListener('focusout', (event) => {
        if (!desktopMedia.matches) return;
        if (trigger.contains(event.relatedTarget)) return;
        scheduleHide();
      });

      // Tab from the trigger should move into the open panel (which lives
      // elsewhere in the DOM for layout reasons), not skip past it to the
      // next nav item.
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || event.shiftKey) return;
        if (!desktopMedia.matches) return;
        if (trigger.getAttribute('aria-expanded') !== 'true') return;
        const panel = hoverBar.querySelector(`[data-hover-panel="${handle}"]`);
        const firstFocusable = panel && panel.querySelector('a, button');
        if (!firstFocusable) return;
        event.preventDefault();
        firstFocusable.focus();
      });
    });

    hoverBar.addEventListener('mouseenter', clearHideTimeout);
    hoverBar.addEventListener('mouseleave', scheduleHide);
    hoverBar.addEventListener('focusin', clearHideTimeout);
    hoverBar.addEventListener('focusout', scheduleHide);

    // Escape closes the open panel and returns focus to its trigger.
    hoverBar.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      deactivate();
      if (lastTrigger) lastTrigger.focus();
    });

    window.addEventListener('scroll', () => {
      if (!hoverBar.classList.contains('collection-hover--visible')) return;
      deactivate();
    }, { passive: true });

    desktopMedia.addEventListener('change', (event) => {
      if (!event.matches) {
        deactivate();
      }
    });
  };

  initializeCollectionHover();

  // Style-level hover — activates product-type sub-panel when hovering a style button
  const initStyleHover = () => {
    document.querySelectorAll('.collection-hover__style-btn').forEach((btn) => {
      const activateStyle = () => {
        const panel = btn.closest('.collection-hover__panel');
        if (!panel) return;
        panel.querySelectorAll('.collection-hover__style-btn').forEach((b) => b.classList.remove('is-active'));
        panel.querySelectorAll('.collection-hover__style-panel').forEach((p) => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        const target = panel.querySelector(`.collection-hover__style-panel[data-style-panel="${btn.dataset.styleHandle}"]`);
        if (target) target.classList.add('is-active');
      };
      btn.addEventListener('mouseenter', activateStyle);
      btn.addEventListener('focusin', activateStyle);
    });
  };
  initStyleHover();

  const staticHeaderWrapper = document.querySelector('.section-header .header-wrapper');
  if (staticHeaderWrapper && staticHeaderWrapper.tagName !== 'STICKY-HEADER' && !staticHeaderWrapper.dataset.transparentHeaderInitialized) {
    staticHeaderWrapper.dataset.transparentHeaderInitialized = 'true';
    const allowStaticTransparentHeader = staticHeaderWrapper.dataset.transparentHeader === 'true';
    let staticTransparentState = false;
    let staticDarkSchemeActive = false;
    let staticSchemeMediaQuery;
    let staticSchemeListener;
    let staticDesktopMediaQuery;
    let staticDesktopListener;
    let staticIsDesktopViewport = true;
    let staticMobileSurfaceIsDark = false;

    const applyStaticLogoState = () => {
      const allowScrollSwap = staticIsDesktopViewport;
      const scrollContrast = allowScrollSwap && staticTransparentState;
      const schemeContrast = !staticIsDesktopViewport && staticMobileSurfaceIsDark;
      const shouldShowContrast = scrollContrast || schemeContrast;
      staticHeaderWrapper.classList.toggle('header-wrapper--show-contrast-logo', shouldShowContrast);
      const logoWrappers = staticHeaderWrapper.querySelectorAll('.header__heading-logo-wrapper--dual');
      if (!logoWrappers.length) {
        return;
      }
      logoWrappers.forEach((wrapper) => {
        wrapper.classList.toggle('header__heading-logo-wrapper--show-contrast', shouldShowContrast);
      });
    };

    const updateStaticSchemeClasses = () => {
      const allowMobileScheme = !staticIsDesktopViewport;
      const applyDarkScheme = allowMobileScheme && staticDarkSchemeActive;
      staticHeaderWrapper.classList.toggle('header-wrapper--color-scheme-dark', applyDarkScheme);
      if (staticIsDesktopViewport) {
        staticHeaderWrapper.classList.remove('header-wrapper--color-scheme-dark');
      }
    };

    const syncStaticMobileSurfaceState = (options = {}) => {
      const { skipLogoUpdate = false } = options;
      if (staticIsDesktopViewport) {
        if (staticMobileSurfaceIsDark || staticHeaderWrapper.classList.contains('header-wrapper--mobile-dark-surface') || staticHeaderWrapper.classList.contains('header-wrapper--mobile-light-surface')) {
          staticMobileSurfaceIsDark = false;
          staticHeaderWrapper.classList.remove('header-wrapper--mobile-dark-surface', 'header-wrapper--mobile-light-surface');
          if (!skipLogoUpdate) {
            applyStaticLogoState();
          }
        }
        return;
      }

      const backgroundColor = window.getComputedStyle(staticHeaderWrapper).backgroundColor;
      const isDarkSurface = isDarkSurfaceColor(backgroundColor);
      if (staticMobileSurfaceIsDark === isDarkSurface && staticHeaderWrapper.classList.contains('header-wrapper--mobile-dark-surface') === isDarkSurface) {
        return;
      }

      staticMobileSurfaceIsDark = isDarkSurface;
      staticHeaderWrapper.classList.toggle('header-wrapper--mobile-dark-surface', isDarkSurface);
      staticHeaderWrapper.classList.toggle('header-wrapper--mobile-light-surface', !isDarkSurface);

      if (!skipLogoUpdate) {
        applyStaticLogoState();
      }
    };

    const updateStaticColorScheme = (matches) => {
      staticDarkSchemeActive = matches;
      updateStaticSchemeClasses();
      syncStaticMobileSurfaceState();
      applyStaticLogoState();
    };

    const initializeStaticColorSchemeWatcher = () => {
      if (typeof window.matchMedia !== 'function') return;
      staticSchemeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      if (!staticSchemeMediaQuery) return;
      staticSchemeListener = (event) => updateStaticColorScheme(event.matches);
      updateStaticColorScheme(staticSchemeMediaQuery.matches);
      if (typeof staticSchemeMediaQuery.addEventListener === 'function') {
        staticSchemeMediaQuery.addEventListener('change', staticSchemeListener);
      } else if (typeof staticSchemeMediaQuery.addListener === 'function') {
        staticSchemeMediaQuery.addListener(staticSchemeListener);
      }
    };

    const initializeStaticDesktopWatcher = () => {
      if (typeof window.matchMedia !== 'function') return;
      staticDesktopMediaQuery = window.matchMedia(DESKTOP_LOGO_MEDIA_QUERY);
      if (!staticDesktopMediaQuery) return;
      const applyDesktopState = (matches) => {
        staticIsDesktopViewport = matches;
        updateStaticSchemeClasses();
        syncStaticMobileSurfaceState({ skipLogoUpdate: true });
        applyStaticLogoState();
      };
      staticDesktopListener = (event) => applyDesktopState(event.matches);
      applyDesktopState(staticDesktopMediaQuery.matches);
      if (typeof staticDesktopMediaQuery.addEventListener === 'function') {
        staticDesktopMediaQuery.addEventListener('change', staticDesktopListener);
      } else if (typeof staticDesktopMediaQuery.addListener === 'function') {
        staticDesktopMediaQuery.addListener(staticDesktopListener);
      }
    };

    const toggleStaticHeaderBackground = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const atTop = scrollTop <= TRANSPARENT_HEADER_SCROLL_THRESHOLD;
      const allowDesktopTransparent = allowStaticTransparentHeader && staticIsDesktopViewport;
      const showTransparentState = allowDesktopTransparent && atTop;
      staticHeaderWrapper.classList.toggle('header-wrapper--transparent', showTransparentState);
      staticHeaderWrapper.classList.toggle('header-wrapper--solid', !showTransparentState);
      staticTransparentState = showTransparentState;
      syncStaticMobileSurfaceState({ skipLogoUpdate: true });
      applyStaticLogoState();
    };

    initializeStaticColorSchemeWatcher();
    initializeStaticDesktopWatcher();
    toggleStaticHeaderBackground();
    window.addEventListener('scroll', toggleStaticHeaderBackground, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sticky-cta]').forEach(function(cta) {
    var bannerId = cta.getAttribute('data-sticky-cta');
    var banner = document.getElementById(bannerId);
    if (!banner) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        cta.classList.toggle('banner__sticky-cta--visible', entry.isIntersecting);
      });
    }, {threshold: 0.05});
    observer.observe(banner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
